import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../@types/filter";
import { Paginated } from "../../../@types/paginated";
import { apisiseci } from "../../api";
import { useDefaultSearchParams } from "../../../hooks/useSearchParams";
import { useCurrentOrgao } from "../../../hooks/useCurrentOrgao";
import { UserList } from "../../../@types/users";

type Props = DefaultFilter & {
  orgao?: string;
  orgao_id?: string;
};

export function useUsersList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const currentOrgaoId = useCurrentOrgao();
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  if (currentOrgaoId && !params.orgao) {
    params = { ...params, orgao_id: currentOrgaoId.toString() };
  }

  return useQuery<Paginated<UserList>, Error>({
    queryKey: ["profiles", "list", params, currentOrgaoId],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<UserList>>(
        "/cms/user_list/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      );
      return response.data;
    },
  });
}
